<template>
  <div>
    <Banner theme="pink">
      <template v-slot:title> Redirects </template>
      <template v-slot:description>
        Redirects let you send visitors from an old or shortened URL on your
        Commons domain to another URL. Use these to keep old links working,
        clean up shared links, or point traffic to a page outside Commons.
      </template>
      <template v-slot:image> </template>
    </Banner>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New Redirect"
      btn-to="/redirects/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search Redirects"
      :search-text.sync="searchText"
    />

    <ListPanels :loaded="!!list">
      <div v-if="computedList && computedList.length" style="width: 100%">
        <RedirectDataTable
          :list="computedList"
          @destroy="destroyRedirect($event)"
        />
      </div>
      <div v-else class="no-entries">No Redirects</div>
    </ListPanels>
  </div>
</template>

<script>
import IndexPage from "./index-page";
import RedirectDataTable from "@/components/dataview/redirect.datatable";

export default {
  name: "RedirectsPage",
  components: {
    RedirectDataTable,
  },
  extends: IndexPage,
  metaInfo() {
    return {
      title: "Redirects",
    };
  },
  data() {
    return {
      searchFields: ["title", "url", "absolute_url"],
    };
  },
  methods: {
    async fetchList() {
      const { data } = await this.$api.Page.get({
        sort_by: this.sortBy,
      });
      this.list = data.filter((page) => page.url_type == "redirect");
    },
    async destroyRedirect(redirect) {
      const confirmed = await this.$confirmWindow({
        title: "Are you sure?",
      });
      if (!confirmed) return;

      await this.$api.Page.destroy({ id: redirect.id });
      this.list = this.list.filter((t) => t.id != redirect.id);
    },
  },
};
</script>

<style scoped lang="scss"></style>
